import styled from 'styled-components';

export default styled.div`
  padding: 2em;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;

  .doc-header {
    margin-bottom: 3em;

    .header-content {
      display: flex;
      gap: 1.5em;
      align-items: flex-start;

      .header-icon {
        font-size: 3rem;
        color: ${({ theme }) => theme.primary};
        flex-shrink: 0;
      }

      h1 {
        font-size: 2.5rem;
        color: #fff;
        margin: 0 0 0.5em 0;
      }

      p {
        color: rgba(255, 255, 255, 0.7);
        font-size: 1.1rem;
        margin: 0;
      }
    }
  }

  .doc-content {
    display: flex;
    flex-direction: column;
    gap: 3em;
  }

  .doc-section {
    background: #1a1d35;
    border-radius: 12px;
    padding: 2em;
    border: 1px solid rgba(255, 255, 255, 0.05);

    .section-header {
      display: flex;
      align-items: center;
      gap: 1em;
      margin-bottom: 1.5em;
      padding-bottom: 1em;
      border-bottom: 2px solid rgba(255, 255, 255, 0.1);

      .section-icon {
        font-size: 1.75rem;
        color: ${({ theme }) => theme.primary};
      }

      h2 {
        color: #fff;
        margin: 0;
        font-size: 1.75rem;
      }
    }

    .section-content {
      color: rgba(255, 255, 255, 0.85);
      line-height: 1.7;

      p {
        margin: 0 0 1em 0;
      }

      a {
        color: ${({ theme }) => theme.primary};
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      code {
        background: rgba(0, 0, 0, 0.4);
        padding: 0.2em 0.5em;
        border-radius: 4px;
        font-family: 'Courier New', monospace;
        font-size: 0.9em;
        color: #81C784;
      }
    }
  }

  .step-list {
    margin: 0;
    padding-left: 1.5em;
    list-style: decimal;

    li {
      margin-bottom: 1em;
      line-height: 1.7;

      strong {
        color: #fff;
      }
    }
  }

  .event-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1em;
    margin-top: 1em;
  }

  .event-card {
    padding: 1.25em;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-left: 4px solid;
    border-radius: 8px;

    .event-name {
      font-family: 'Courier New', monospace;
      font-weight: 600;
      font-size: 1rem;
      margin-bottom: 0.5em;
    }

    .event-description {
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.9rem;
    }
  }

  .code-block-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    padding: 0.75em 1.25em;
    border-radius: 8px 8px 0 0;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: none;

    span {
      color: rgba(255, 255, 255, 0.8);
      font-weight: 600;
      font-size: 0.9rem;
    }

    .copy-btn {
      display: flex;
      align-items: center;
      gap: 0.5em;
      padding: 0.5em 1em;
      background: rgba(254, 125, 17, 0.2);
      border: 1px solid ${({ theme }) => theme.primary};
      border-radius: 6px;
      color: ${({ theme }) => theme.primary};
      font-weight: 600;
      font-size: 0.85rem;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(254, 125, 17, 0.3);
      }
    }
  }

  .code-block {
    margin: 0;
    padding: 1.5em;
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 0 0 8px 8px;
    color: #A5D6A7;
    font-family: 'Courier New', monospace;
    font-size: 0.85rem;
    overflow-x: auto;
    line-height: 1.6;
    white-space: pre;
  }

  .example-block {
    margin-bottom: 2em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .info-box {
    display: flex;
    gap: 1em;
    padding: 1.25em;
    background: rgba(255, 152, 0, 0.1);
    border: 1px solid rgba(255, 152, 0, 0.3);
    border-radius: 8px;
    margin-top: 1.5em;

    svg {
      font-size: 1.5rem;
      color: #FFB74D;
      flex-shrink: 0;
    }

    &.success {
      background: rgba(76, 175, 80, 0.1);
      border-color: rgba(76, 175, 80, 0.3);

      svg {
        color: #81C784;
      }
    }

    strong {
      color: #fff;
    }
  }

  .headers-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1em;

    thead {
      background: rgba(0, 0, 0, 0.3);

      th {
        padding: 1em;
        text-align: left;
        color: #fff;
        font-weight: 600;
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
    }

    tbody {
      tr {
        border: 1px solid rgba(255, 255, 255, 0.05);

        &.success-row {
          background: rgba(76, 175, 80, 0.05);
        }

        &.error-row {
          background: rgba(244, 67, 54, 0.05);
        }

        &:hover {
          background: rgba(255, 255, 255, 0.03);
        }
      }

      td {
        padding: 1em;
        border: 1px solid rgba(255, 255, 255, 0.05);
        color: rgba(255, 255, 255, 0.85);

        code {
          background: rgba(0, 0, 0, 0.4);
          padding: 0.3em 0.6em;
          border-radius: 4px;
          font-family: 'Courier New', monospace;
          color: #81C784;
        }
      }
    }
  }

  .best-practices-list {
    margin: 0;
    padding-left: 1.5em;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 1.25em;
      line-height: 1.7;
      padding-left: 1.5em;

      &:before {
        content: '✓';
        position: absolute;
        left: 0;
        color: #81C784;
        font-weight: bold;
        font-size: 1.2rem;
      }

      strong {
        color: #fff;
      }
    }
  }

  .troubleshooting-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 1.5em;
    margin-top: 1em;

    .trouble-item {
      padding: 1.5em;
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 255, 255, 0.05);
      border-radius: 8px;

      h4 {
        color: #fff;
        margin: 0 0 1em 0;
        font-size: 1.1rem;
      }

      ul {
        margin: 0;
        padding-left: 1.5em;
        list-style: disc;

        li {
          margin-bottom: 0.5em;
          color: rgba(255, 255, 255, 0.7);
          line-height: 1.5;
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 1em;

    .doc-header {
      margin-bottom: 2em;

      .header-content {
        h1 {
          font-size: 1.75rem;
        }

        p {
          font-size: 1rem;
        }
      }
    }

    .doc-section {
      padding: 1.5em;

      .section-header {
        h2 {
          font-size: 1.5rem;
        }
      }
    }

    .event-grid {
      grid-template-columns: 1fr;
    }

    .troubleshooting-grid {
      grid-template-columns: 1fr;
    }

    .code-block {
      font-size: 0.75rem;
    }
  }
`;
